import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import ErrorBoundary from '../../../../components/molecules/ErrorBoundary'
import AbundanceParser from '../../../../abundanceEngine/AbundanceParser'

const useStyles = makeStyles((theme) => ({
  container: {
    margin: '16px 0',
    padding: theme.spacing(2),
    backgroundColor: 'var(--dai-color-bg-inline)',
    borderRadius: 'var(--border-radius-md)',
    border: '1px solid var(--dai-color-border1)',
    overflow: 'hidden'
  },
  errorContainer: {
    padding: theme.spacing(2),
    backgroundColor: '#fff3cd',
    border: '1px solid #ffeaa7',
    borderRadius: theme.shape.borderRadius,
    color: '#856404'
  }
}))

function InlineAbundanceRenderer ({ code }) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <ErrorBoundary
        name='Inline Abundance Chart'
        fallback={(
          <div className={classes.errorContainer}>
            Failed to render chart. Please check the JSX syntax.
          </div>
        )}
      >
        <AbundanceParser jsx={code} />
      </ErrorBoundary>
    </div>
  )
}

InlineAbundanceRenderer.propTypes = {
  code: PropTypes.string.isRequired
}

export default InlineAbundanceRenderer
